"use strict";

exports.__esModule = true;
exports.IkConstraintData = void 0;

var _ConstraintData2 = require("./ConstraintData");

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/** Stores the setup pose for an {@link IkConstraint}.
 * <p>
 * See [IK constraints](http://esotericsoftware.com/spine-ik-constraints) in the Spine User Guide. */
var IkConstraintData = /*#__PURE__*/function (_ConstraintData) {
  _inheritsLoose(IkConstraintData, _ConstraintData);

  function IkConstraintData(name) {
    var _this;

    _this = _ConstraintData.call(this, name, 0, false) || this;
    /** The bones that are constrained by this IK constraint. */

    _this.bones = new Array();
    /** The bone that is the IK target. */

    _this.target = null;
    /** Controls the bend direction of the IK bones, either 1 or -1. */

    _this.bendDirection = 1;
    /** When true and only a single bone is being constrained, if the target is too close, the bone is scaled to reach it. */

    _this.compress = false;
    /** When true, if the target is out of range, the parent bone is scaled to reach it. If more than one bone is being constrained
     * and the parent bone has local nonuniform scale, stretch is not applied. */

    _this.stretch = false;
    /** When true, only a single bone is being constrained, and {@link #getCompress()} or {@link #getStretch()} is used, the bone
     * is scaled on both the X and Y axes. */

    _this.uniform = false;
    /** A percentage (0-1) that controls the mix between the constrained and unconstrained rotations. */

    _this.mix = 1;
    /** For two bone IK, the distance from the maximum reach of the bones that rotation will slow. */

    _this.softness = 0;
    return _this;
  }

  return IkConstraintData;
}(_ConstraintData2.ConstraintData);

exports.IkConstraintData = IkConstraintData;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7QUE4QkE7Ozs7OztBQUdBOzs7SUFHYUEsZ0I7OztFQTJCWiwwQkFBYUMsSUFBYixFQUF5QjtJQUFBOztJQUN4QixtQ0FBTUEsSUFBTixFQUFZLENBQVosRUFBZSxLQUFmO0lBM0JEOztJQUNBLGNBQVEsSUFBSUMsS0FBSixFQUFSO0lBRUE7O0lBQ0EsZUFBbUIsSUFBbkI7SUFFQTs7SUFDQSxzQkFBZ0IsQ0FBaEI7SUFFQTs7SUFDQSxpQkFBVyxLQUFYO0lBRUE7OztJQUVBLGdCQUFVLEtBQVY7SUFFQTs7O0lBRUEsZ0JBQVUsS0FBVjtJQUVBOztJQUNBLFlBQU0sQ0FBTjtJQUVBOztJQUNBLGlCQUFXLENBQVg7SUFFeUI7RUFFeEI7OztFQTdCb0NDLCtCIiwibmFtZXMiOlsiSWtDb25zdHJhaW50RGF0YSIsIm5hbWUiLCJBcnJheSIsIkNvbnN0cmFpbnREYXRhIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9Ja0NvbnN0cmFpbnREYXRhLnRzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19